import { render, staticRenderFns } from "./MoneyTransferIcon.vue?vue&type=template&id=772fed2f"
import script from "./MoneyTransferIcon.vue?vue&type=script&lang=js"
export * from "./MoneyTransferIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports